var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#523d3d",
    opacity: 0.9803921568627451,
    "data-original": "#000000",
    className: ""
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20M0 0v20",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 514.667 428.733)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-80M0 0v-80",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 354.667 322.067)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-64.843c0-33.13-13.43-73.13-35.15-94.85-21.71-21.72-51.71-35.15-84.85-35.15h-47.44c-73.211 0-132.56 69.349-132.56 142.56v0c0 33.137 26.863 60 60 60v142.89c0 8.28 3.36 15.78 8.79 21.21 5.586 5.586 13.363 8.981 21.926 8.781C-192.896 180.216-180 166.393-180 150V60.607c0 8.28 3.36 15.78 8.79 21.21 5.43 5.43 12.93 8.79 21.21 8.79 8.28 0 15.78-3.36 21.21-8.79 5.43-5.43 8.79-12.93 8.79-21.21v-30c0 8.28 3.36 15.78 8.79 21.21 5.43 5.43 12.93 8.79 21.21 8.79 8.28 0 15.78-3.36 21.21-8.79 5.43-5.43 8.79-12.93 8.79-21.21v-30c0 8.28 3.36 15.78 8.79 21.21 5.586 5.586 13.363 8.981 21.926 8.781C-12.896 30.216 0 16.393 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(446 209.843)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-50",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(326 240.45)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-52.663",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(206 217.56)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c22.46 8.67 38.38 30.46 38.38 55.98 0 33.14-26.86 60-60 60s-60-26.86-60-60c0-25.46 15.85-47.21 38.23-55.93",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(257.62 381.02)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-161l36 36",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(176 437)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 36-36",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(15 437)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h201l-36 36",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(296 437)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-36-36",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(497 437)",
    fill: "none",
    stroke: "#523d3d",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 0.9803921568627451
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.b36d4707adb5bde20273cb08b56e5f7e.svg";
export { ForwardRef as ReactComponent };